var render = function render(){var _vm=this,_c=_vm._self._c;return _c('tabs',{attrs:{"tabs":_vm.tabs,"selectedTab":_vm.selectedTab,"showing":_vm.showing,"bgClass":'bg-white',"borderClass":'border-color-light-gray bordered-tab-item',"itemTextClass":'color-custom-dark-grey',"itemBGClass":'bg-dark-gray'},on:{"select-tab":_vm.selectTab,"remove-tab":_vm.removeTab,"update-tab":_vm.updateTab,"add-tab":_vm.addTab}})
}
var staticRenderFns = []

export { render, staticRenderFns }